import { ACCEPTING_ORDER_ID, BECOME_BRAND_ID, BRAND_POLICIES_ID, CANCELING_AN_ORDER_ID, CONTACTING_MY_RETAILER_ID, CONTACT_A_BRAND_ID, DISPUTE_A_RETAILER_COMPLAINT_ID, EU_DSA_ID, FAIRE_ACCOUNT_SECURITY_ID, FAIRE_COST_ID, HOW_AM_I_NOTIFIED_NEW_ORDERS_ID, HOW_DO_NET_60_TERMS_WORK_ID, HOW_SHOULD_I_BE_SELLING_MY_FAIRE_PRODUCTS_ID, ISSUE_WITH_MY_ORDER_PAYOUT_ID, MAKE_A_RETURN_ID, NAM_SELL_ON_FAIRE_ID, NON_NAM_SELL_ON_FAIRE_ID, ORDER_INVOICE_ID, ORDER_STATUS_ID, PAYOUT_AUSTRALIAN_ID, PAYOUT_CALCULATED_ID, PAYOUT_CANADIAN_ID, PAYOUT_EUROPEAN_ID, REPORT_DAMAGED_MISSING_ID, RETAILER_WHAT_IS_FAIRE_ID, SETTING_UP_PAYOUT_ID, TAX_FORM_1099_ID, TROUBLESHOOTING_WITH_ADYEN_ID, WHERE_IS_FAIRE_AVAILABLE_ID } from "@faire/help-center-utils/articleIds";
import { Article } from "@faire/help-center-utils/articles";
import { useStrictLocalization } from "@faire/web/common/localization";
export var useArticles = function useArticles() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = {
    GettingStarted: {
      COMPLETING_ONBOARDING_FORM: new Article({
        name: strictLocalize({
          id: "C6NF6S",
          defaultMessage: [{
            "type": 0,
            "value": "Remplir mon formulaire d'intégration"
          }]
        }),
        id: "360039212391"
      }),
      UPLOAD_FIRST_CATALOG: new Article({
        name: strictLocalize({
          id: "AlDz2c",
          defaultMessage: [{
            "type": 0,
            "value": "Importer votre catalogue de produits"
          }]
        }),
        id: "4416016600347"
      }),
      RESELLER_ID: new Article({
        name: strictLocalize({
          id: "POZmQR",
          defaultMessage: [{
            "type": 0,
            "value": "Ai-je besoin d'un identifiant de revendeur ?"
          }]
        }),
        id: "360016203651"
      }),
      BRICK_AND_MORTAR: new Article({
        name: strictLocalize({
          id: "HlhWGa",
          defaultMessage: [{
            "type": 0,
            "value": "Que faire si je n'ai pas de boutique physique ?"
          }]
        }),
        id: "360016111231"
      }),
      OPEN_WITH_FAIRE: new Article({
        name: strictLocalize({
          id: "kG9smm",
          defaultMessage: [{
            "type": 0,
            "value": "Opening with Faire"
          }]
        }),
        id: "4645924980763"
      })
    },
    MyOrders: {
      HOW_AM_I_NOTIFIED_NEW_ORDERS: new Article({
        name: strictLocalize({
          id: "DDqsse",
          defaultMessage: [{
            "type": 0,
            "value": "Comment les nouvelles commandes me sont-elles communiquées ?"
          }]
        }),
        id: HOW_AM_I_NOTIFIED_NEW_ORDERS_ID
      }),
      HOW_SHOULD_I_BE_SELLING_MY_FAIRE_PRODUCT: new Article({
        name: strictLocalize({
          id: "FLONHc",
          defaultMessage: [{
            "type": 0,
            "value": "Quelles sont les règles applicables à la revente des produits commandés sur Faire ?"
          }]
        }),
        id: HOW_SHOULD_I_BE_SELLING_MY_FAIRE_PRODUCTS_ID
      }),
      BUSINESS_PROFILE: new Article({
        name: strictLocalize({
          id: "uNwAAN",
          defaultMessage: [{
            "type": 0,
            "value": "Quelles informations sont nécessaires pour le profil de mon magasin ?"
          }]
        }),
        id: "360035578692"
      }),
      SYNC_SQUARE_POS: new Article({
        name: strictLocalize({
          id: "CuRF0T",
          defaultMessage: [{
            "type": 0,
            "value": "Intégrer mon TPV à Faire"
          }]
        }),
        id: "360037248712"
      }),
      FAIRE_PROTECTION: new Article({
        name: strictLocalize({
          id: "ymeN0d",
          defaultMessage: [{
            "type": 0,
            "value": "Qu'est-ce que Faire Protection ?"
          }]
        }),
        id: "360016111511"
      }),
      REPORT_DAMAGED_MISSING: new Article({
        name: strictLocalize({
          id: "v9kPYq",
          defaultMessage: [{
            "type": 0,
            "value": "Comment signaler des articles endommagés ou manquants ?"
          }]
        }),
        id: REPORT_DAMAGED_MISSING_ID
      }),
      ORDER_STATUS: new Article({
        name: strictLocalize({
          id: "t0xr1I",
          defaultMessage: [{
            "type": 0,
            "value": "Quand vais-je recevoir mes commandes ?"
          }]
        }),
        id: ORDER_STATUS_ID
      }),
      ORDER_RETURNED_TO_SENDER: new Article({
        name: strictLocalize({
          id: "9S0FTQ",
          defaultMessage: [{
            "type": 0,
            "value": "Commande retournée à l'expéditeur"
          }]
        }),
        id: "26594585812891"
      }),
      ORDER_QUESTIONS: new Article({
        name: strictLocalize({
          id: "9LqEo1",
          defaultMessage: [{
            "type": 0,
            "value": "Questions sur un article"
          }]
        }),
        id: "360006953111"
      }),
      BRAND_MINIMUMS: new Article({
        name: strictLocalize({
          id: "w5vD/I",
          defaultMessage: [{
            "type": 0,
            "value": "Que sont les montants minimums de commande ?"
          }]
        }),
        id: "360016302912"
      }),
      CANCELING_AN_ORDER: new Article({
        name: strictLocalize({
          id: "0VnS38",
          defaultMessage: [{
            "type": 0,
            "value": "Comment puis-je annuler une commande ?"
          }]
        }),
        id: CANCELING_AN_ORDER_ID
      }),
      CONTACT_A_BRAND: new Article({
        name: strictLocalize({
          id: "SjOF+W",
          defaultMessage: [{
            "type": 0,
            "value": "Comment puis-je contacter une marque sur Faire ?"
          }]
        }),
        id: CONTACT_A_BRAND_ID
      })
    },
    ManageMyShop: {
      ADD_EDIT_PRODUCTS: new Article({
        name: strictLocalize({
          id: "9Rgpw6",
          defaultMessage: [{
            "type": 0,
            "value": "Comment ajouter ou modifier des produits ?"
          }]
        }),
        id: "360006829831"
      }),
      BRAND_PROMOTION_CALCULATED: new Article({
        name: strictLocalize({
          id: "/rgb2v",
          defaultMessage: [{
            "type": 0,
            "value": "Comment les promotions sont-elles calculées ?"
          }]
        }),
        id: "360032489472"
      }),
      CUSTOMIZE_MY_PRODUCT_TRANSLATIONS: new Article({
        name: strictLocalize({
          id: "5p35uh",
          defaultMessage: [{
            "type": 0,
            "value": "Puis-je personnaliser les traductions de mes produits ?"
          }]
        }),
        id: "7652446722331"
      }),
      CURRENCY_SPECIFIC_PRICING: new Article({
        name: strictLocalize({
          id: "W+2iJv",
          defaultMessage: [{
            "type": 0,
            "value": "Tarification spécifique par devise"
          }]
        }),
        id: "360055558732"
      }),
      SETTING_PRODUCT_INVENTORY_LEVELS: new Article({
        name: strictLocalize({
          id: "2saxOG",
          defaultMessage: [{
            "type": 0,
            "value": "Définir les niveaux de stock de mes produits"
          }]
        }),
        id: "360045187791"
      }),
      ARRANGE_MY_SHOP_LISTINGS: new Article({
        name: strictLocalize({
          id: "kspgKw",
          defaultMessage: [{
            "type": 0,
            "value": "Comment organiser les produits de ma boutique ?"
          }]
        }),
        id: "360039477271"
      }),
      WHAT_IS_EXCLUSIVITY_PROGRAM: new Article({
        name: strictLocalize({
          id: "Ddnv4m",
          defaultMessage: [{
            "type": 0,
            "value": "Qu'est-ce que le programme d'exclusivité géographique ?"
          }]
        }),
        id: "18543447335451"
      })
    },
    Referrals: {
      CAN_I_REFER_BRANDS_TO_FAIRE: new Article({
        name: strictLocalize({
          id: "TG9PtX",
          defaultMessage: [{
            "type": 0,
            "value": "Puis-je parrainer des marques sur Faire ?"
          }]
        }),
        id: "4404937922587"
      }),
      USE_REFERRAL_PROMOTION: new Article({
        name: strictLocalize({
          id: "FJ+m6x",
          defaultMessage: [{
            "type": 0,
            "value": "Comment puis-je utiliser une promotion de parrainage offerte par une marque ?"
          }]
        }),
        id: "360034300092"
      })
    },
    OptimizingMyPage: {
      COVER_IMAGE_GUIDELINES: new Article({
        name: strictLocalize({
          id: "fXnXFB",
          defaultMessage: [{
            "type": 0,
            "value": "Directives relatives aux images de couverture"
          }]
        }),
        id: "360016791851"
      }),
      PRODUCT_PHOTOGRAPHY_GUIDELINES: new Article({
        name: strictLocalize({
          id: "YINiMH",
          defaultMessage: [{
            "type": 0,
            "value": "Directives sur les photos de produits"
          }]
        }),
        id: "360016568092"
      }),
      IMAGE_SIZE_REQUIREMENTS: new Article({
        name: strictLocalize({
          id: "lXeU3d",
          defaultMessage: [{
            "type": 0,
            "value": "Exigences en matière de taille d'image"
          }]
        }),
        id: "360032130371"
      }),
      BRAND_STORY_GUIDELINES: new Article({
        name: strictLocalize({
          id: "d3h1Ep",
          defaultMessage: [{
            "type": 0,
            "value": "Directives relatives aux histoires des marques"
          }]
        }),
        id: "360026756912"
      }),
      ADD_VIDEO: new Article({
        name: strictLocalize({
          id: "LJd4Gb",
          defaultMessage: [{
            "type": 0,
            "value": "Puis-je ajouter une vidéo à ma boutique ?"
          }]
        }),
        id: "360054846452"
      })
    },
    InvoicesAndBilling: {
      RECEIVE_ORDER_INVOICE: new Article({
        name: strictLocalize({
          id: "X9dXUE",
          defaultMessage: [{
            "type": 0,
            "value": "Vais-je recevoir une facture pour ma commande ?"
          }]
        }),
        id: "4408351766171"
      }),
      PRODUCT_REPORT: new Article({
        name: strictLocalize({
          id: "DE+DLf",
          defaultMessage: [{
            "type": 0,
            "value": "Que se passe-t-il si un commerçant signale un produit manquant ou endommagé ?"
          }]
        }),
        id: "360033568051"
      }),
      PAYOUT_CALCULATED: new Article({
        name: strictLocalize({
          id: "eE3x7A",
          defaultMessage: [{
            "type": 0,
            "value": "Comment mon paiement est-il calculé ?"
          }]
        }),
        id: PAYOUT_CALCULATED_ID
      }),
      PAYOUT_EUROPEAN: new Article({
        name: strictLocalize({
          id: "OiNzBj",
          defaultMessage: [{
            "type": 0,
            "value": "Comment puis-je configurer les paiements sur un compte bancaire européen ?"
          }]
        }),
        id: PAYOUT_EUROPEAN_ID
      }),
      PAYOUT_AUSTRALIAN: new Article({
        name: strictLocalize({
          id: "NsyCP6",
          defaultMessage: [{
            "type": 0,
            "value": "Comment puis-je configurer les paiements sur un compte bancaire australien ?"
          }]
        }),
        id: PAYOUT_AUSTRALIAN_ID
      }),
      PAYOUT_CANADIAN: new Article({
        name: strictLocalize({
          id: "M1uK1z",
          defaultMessage: [{
            "type": 0,
            "value": "Paiements pour les marques canadiennes"
          }]
        }),
        id: PAYOUT_CANADIAN_ID
      }),
      ISSUE_WITH_MY_ORDER_PAYOUT: new Article({
        name: strictLocalize({
          id: "GeTSEg",
          defaultMessage: [{
            "type": 0,
            "value": "Problème avec le paiement de ma commande"
          }]
        }),
        id: ISSUE_WITH_MY_ORDER_PAYOUT_ID
      }),
      TAX_FORM_1099: new Article({
        name: strictLocalize({
          id: "P/vdrr",
          defaultMessage: [{
            "type": 0,
            "value": "Vais-je recevoir un formulaire 1099-K ?"
          }]
        }),
        id: TAX_FORM_1099_ID
      }),
      SETTING_UP_PAYOUT: new Article({
        name: strictLocalize({
          id: "qkrW6t",
          defaultMessage: [{
            "type": 0,
            "value": "Configuration de votre compte de paiement"
          }]
        }),
        id: SETTING_UP_PAYOUT_ID
      }),
      TROUBLESHOOTING_WITH_ADYEN: new Article({
        name: strictLocalize({
          id: "ipXayn",
          defaultMessage: [{
            "type": 0,
            "value": "Résolution des problèmes avec Adyen"
          }]
        }),
        id: TROUBLESHOOTING_WITH_ADYEN_ID
      }),
      PAYOUT_ISSUE: new Article({
        name: strictLocalize({
          id: "GeTSEg",
          defaultMessage: [{
            "type": 0,
            "value": "Problème avec le paiement de ma commande"
          }]
        }),
        id: "360006915532"
      }),
      TAX_INFORMATION: new Article({
        name: strictLocalize({
          id: "/xy/gD",
          defaultMessage: [{
            "type": 0,
            "value": "Paramétrer les informations fiscales"
          }]
        }),
        id: "360038950092"
      }),
      NAM_SELL_ON_FAIRE: new Article({
        name: strictLocalize({
          id: "ztJJ3l",
          defaultMessage: [{
            "type": 0,
            "value": "Combien coûte la vente sur Faire si ma marque est basée en Amérique du Nord ?"
          }]
        }),
        id: NAM_SELL_ON_FAIRE_ID
      }),
      NON_NAM_SELL_ON_FAIRE: new Article({
        name: strictLocalize({
          id: "0wp1lr",
          defaultMessage: [{
            "type": 0,
            "value": "Combien coûte la vente sur Faire si ma marque est basée en dehors de l'Amérique du Nord ?"
          }]
        }),
        id: NON_NAM_SELL_ON_FAIRE_ID
      })
    },
    Account: {
      ORDER_ISSUE: new Article({
        name: strictLocalize({
          id: "CuhRSF",
          defaultMessage: [{
            "type": 0,
            "value": "Pourquoi ne puis-je pas voir la commande de mon commerçant sur mon compte ?"
          }]
        }),
        id: "4415920212123"
      }),
      CANNOT_FIND_ORDER_NUMBER: new Article({
        name: strictLocalize({
          id: "BBAJ+h",
          defaultMessage: [{
            "type": 0,
            "value": "Je ne parviens pas à trouver le numéro de commande d'un commerçant. Pourquoi ?"
          }]
        }),
        id: "4402385627163"
      }),
      NOT_OPEN: new Article({
        name: strictLocalize({
          id: "nWFeyz",
          defaultMessage: [{
            "type": 0,
            "value": "Mon magasin n'est pas encore ouvert. Puis-je déjà commander ?"
          }]
        }),
        id: "360016111571"
      }),
      ACCOUNT_EMAIL: new Article({
        name: strictLocalize({
          id: "yV7GVR",
          defaultMessage: [{
            "type": 0,
            "value": "Modifier mon adresse e-mail de connexion"
          }]
        }),
        id: "360016302272"
      }),
      MANAGE_TEAMS: new Article({
        name: strictLocalize({
          id: "Z1h57J",
          defaultMessage: [{
            "type": 0,
            "value": "Configurez votre équipe sur Faire"
          }]
        }),
        id: "8675579278619"
      }),
      EMAIL_NOTIFICATIONS: new Article({
        name: strictLocalize({
          id: "Xbq6xK",
          defaultMessage: [{
            "type": 0,
            "value": "Puis-je me désabonner de certains e-mails de Faire ? "
          }]
        }),
        id: "360059197351"
      }),
      EMAIL_PREFERENCES: new Article({
        name: strictLocalize({
          id: "o547a2",
          defaultMessage: [{
            "type": 0,
            "value": "Définitions de vos préférences en matière d'e-mails"
          }]
        }),
        id: "360057278792"
      }),
      RESETTING_PASSWORD: new Article({
        name: strictLocalize({
          id: "3o8L8n",
          defaultMessage: [{
            "type": 0,
            "value": "Réinitialiser mon mot de passe"
          }]
        }),
        id: "360019610312"
      }),
      WHAT_IS_EXCLUSIVITY: new Article({
        name: strictLocalize({
          id: "x+S067",
          defaultMessage: [{
            "type": 0,
            "value": "Qu'est-ce que le programme d'exclusivité géographique ?"
          }]
        }),
        id: "19903209185947"
      })
    },
    FaireDirect: {
      ORDER_COMMISSION: new Article({
        name: strictLocalize({
          id: "s4fd/u",
          defaultMessage: [{
            "type": 0,
            "value": "Ma commande Direct fait l'objet d'une commission. Pourquoi ?"
          }]
        }),
        id: "360031800672"
      }),
      ZERO_COMMISSION: new Article({
        name: strictLocalize({
          id: "GTHgGi",
          defaultMessage: [{
            "type": 0,
            "value": "Politique Faire Direct pour les commandes sans commission"
          }]
        }),
        id: "360031800672"
      }),
      EMAIL_CAMPAIGN: new Article({
        name: strictLocalize({
          id: "4SUKRT",
          defaultMessage: [{
            "type": 0,
            "value": "Qu'est-ce qu'une campagne par e-mail ?"
          }]
        }),
        id: "360038731612"
      }),
      EMAIL_AUTOMATIONS: new Article({
        name: strictLocalize({
          id: "YvFUHb",
          defaultMessage: [{
            "type": 0,
            "value": "Que sont les e-mails automatisés ?"
          }]
        }),
        id: "360034668751"
      }),
      FAIRE_DIRECT: new Article({
        name: strictLocalize({
          id: "zTqoXs",
          defaultMessage: [{
            "type": 0,
            "value": "Faire Direct, qu'est-ce que c'est ?"
          }]
        }),
        id: "360032132391"
      }),
      FD_ELIGIBLE: new Article({
        name: strictLocalize({
          id: "zbXaBM",
          defaultMessage: [{
            "type": 0,
            "value": "Qui peut commander via Faire Direct ?"
          }]
        }),
        id: "360032149291"
      }),
      FD_LINK: new Article({
        name: "How do I use my Direct Link?",
        id: "360032133351"
      }),
      WIDGET_GENERAL: new Article({
        name: strictLocalize({
          id: "DHXK5c",
          defaultMessage: [{
            "type": 0,
            "value": "Qu'est-ce que le widget Faire Direct ?"
          }]
        }),
        id: "360040031351"
      }),
      WIDGET_SHOPIFY: new Article({
        name: strictLocalize({
          id: "EqLkX6",
          defaultMessage: [{
            "type": 0,
            "value": "Comment intégrer mon widget Faire Direct à Shopify ?"
          }]
        }),
        id: "10268063927579"
      }),
      WIDGET_WOOCOMMERCE: new Article({
        name: strictLocalize({
          id: "gopKdg",
          defaultMessage: [{
            "type": 0,
            "value": "Comment intégrer mon widget Faire Direct à WooCommerce ?"
          }]
        }),
        id: "24153780884763"
      }),
      WIDGET_PRESTASHOP: new Article({
        name: strictLocalize({
          id: "1FFXmi",
          defaultMessage: [{
            "type": 0,
            "value": "Comment intégrer mon widget Faire Direct sur Prestashop"
          }]
        }),
        id: "25144215925787"
      })
    },
    FulfillingOrders: {
      SPLIT_ATS_ORDER: new Article({
        name: strictLocalize({
          id: "7DQaFp",
          defaultMessage: [{
            "type": 0,
            "value": "Comment diviser une commande prête à expédier ?"
          }]
        }),
        id: "360060488431"
      }),
      SPLIT_PREORDER: new Article({
        name: strictLocalize({
          id: "5Pei21",
          defaultMessage: [{
            "type": 0,
            "value": "Comment diviser une précommande ?"
          }]
        }),
        id: "360060414111"
      }),
      ACCEPTING_ORDER: new Article({
        name: strictLocalize({
          id: "osVMG8",
          defaultMessage: [{
            "type": 0,
            "value": "Accepter une commande"
          }]
        }),
        id: ACCEPTING_ORDER_ID
      }),
      COMMERCIAL_INVOICE: new Article({
        name: strictLocalize({
          id: "WCJyt7",
          defaultMessage: [{
            "type": 0,
            "value": "Comment créer une facture commerciale"
          }]
        }),
        id: "4404314652059"
      }),
      FULFILLING_ORDER: new Article({
        name: strictLocalize({
          id: "hE2Nbm",
          defaultMessage: [{
            "type": 0,
            "value": "Je ne peux pas traiter une commande"
          }]
        }),
        id: "360007184831"
      }),
      UNDERSTAND_ORDER_STATUS: new Article({
        name: strictLocalize({
          id: "5R1ZVj",
          defaultMessage: [{
            "type": 0,
            "value": "Comprendre le statut de votre commande"
          }]
        }),
        id: ORDER_INVOICE_ID
      }),
      CAN_RETAILER_CANCEL_ORDER: new Article({
        name: strictLocalize({
          id: "0UcJaN",
          defaultMessage: [{
            "type": 0,
            "value": "Un commerçant peut-il annuler sa commande ?"
          }]
        }),
        id: "360023102031"
      }),
      SHIPPING_ORDER: new Article({
        name: strictLocalize({
          id: "LTM3/z",
          defaultMessage: [{
            "type": 0,
            "value": "Expédier une commande"
          }]
        }),
        id: "360023300451"
      }),
      SETTING_OUT_OF_STOCK: new Article({
        name: strictLocalize({
          id: "kEJsXY",
          defaultMessage: [{
            "type": 0,
            "value": "Signaler des articles indisponibles ou déréférencés"
          }]
        }),
        id: "360006911352"
      }),
      SHIP_WITH_FAIRE: new Article({
        name: strictLocalize({
          id: "72y5ni",
          defaultMessage: [{
            "type": 0,
            "value": "Expédier avec Faire"
          }]
        }),
        id: "360030933131"
      }),
      LABEL_ISSUES: new Article({
        name: strictLocalize({
          id: "oBNgYb",
          defaultMessage: [{
            "type": 0,
            "value": "Pourquoi un message d'erreur s'affiche-t-il lorsque j'utilise l'option Expédier avec Faire ?"
          }]
        }),
        id: "360040920571"
      }),
      SHIP_ON_YOUR_OWN: new Article({
        name: strictLocalize({
          id: "IlfctE",
          defaultMessage: [{
            "type": 0,
            "value": "Comment expédier des commandes par vos propres moyens"
          }]
        }),
        id: "360030933311"
      }),
      SHIPPING_COSTS: new Article({
        name: strictLocalize({
          id: "SPzcuL",
          defaultMessage: [{
            "type": 0,
            "value": "Gestion des frais d'expédition vers d'autres pays"
          }]
        }),
        id: "360040349352"
      }),
      SHIPPING_WORK: new Article({
        name: strictLocalize({
          id: "ybSoRd",
          defaultMessage: [{
            "type": 0,
            "value": "Comment fonctionne l'expédition ?"
          }]
        }),
        id: "4405859125531"
      }),
      ABOUT_SHIPPING: new Article({
        name: strictLocalize({
          id: "1JAZ0s",
          defaultMessage: [{
            "type": 0,
            "value": "Informations sur l'expédition"
          }]
        }),
        id: "360016111831"
      }),
      SHIPPING_ADDRESS: new Article({
        name: strictLocalize({
          id: "NAicKW",
          defaultMessage: [{
            "type": 0,
            "value": "Comment puis-je changer mon adresse de livraison ?"
          }]
        }),
        id: "360018235292"
      }),
      CHANGE_SHIPPING_ADDRESS: new Article({
        name: strictLocalize({
          id: "v3+vuS",
          defaultMessage: [{
            "type": 0,
            "value": "Puis-je changer mon adresse après l'expédition de ma commande ?"
          }]
        }),
        id: "360007197951"
      }),
      EDIT_RETAILER_ORDER: new Article({
        name: strictLocalize({
          id: "ArjSpz",
          defaultMessage: [{
            "type": 0,
            "value": "Puis-je modifier la commande d'un commerçant ?"
          }]
        }),
        id: "360053212551"
      })
    },
    ReturnsAndRefunds: {
      MAKE_A_RETURN: new Article({
        name: strictLocalize({
          id: "PTuRfO",
          defaultMessage: [{
            "type": 0,
            "value": "Comment puis-je renvoyer des articles ?"
          }]
        }),
        id: MAKE_A_RETURN_ID
      }),
      EXTEND_A_RETURN: new Article({
        name: strictLocalize({
          id: "hDezWS",
          defaultMessage: [{
            "type": 0,
            "value": "Puis-je prolonger mon délai de retour ?"
          }]
        }),
        id: "360022876131"
      }),
      CANT_RETURN: new Article({
        name: strictLocalize({
          id: "F85fJa",
          defaultMessage: [{
            "type": 0,
            "value": "Pourquoi ne puis-je pas retourner mes articles ?"
          }]
        }),
        id: "360007069352"
      })
    },
    PaymentsAndInvoices: {
      CHANGE_MY_PAYMENT_METHOD: new Article({
        name: strictLocalize({
          id: "sRWcLE",
          defaultMessage: [{
            "type": 0,
            "value": "Changer mon mode de paiement"
          }]
        }),
        id: "360018497831"
      }),
      NET_60_TERMS: new Article({
        name: strictLocalize({
          id: "17QDXy",
          defaultMessage: [{
            "type": 0,
            "value": "Comment fonctionne le paiement à 60 jours ?"
          }]
        }),
        id: HOW_DO_NET_60_TERMS_WORK_ID
      }),
      PAY_INVOICES: new Article({
        name: strictLocalize({
          id: "+8Ngr8",
          defaultMessage: [{
            "type": 0,
            "value": "Comment régler mes factures ?"
          }]
        }),
        id: "360006920172"
      }),
      INVOICE_DUE: new Article({
        name: strictLocalize({
          id: "r9dmpJ",
          defaultMessage: [{
            "type": 0,
            "value": "Quand dois-je payer ma facture ?"
          }]
        }),
        id: "360006994232"
      }),
      UNDERSTANDING_ORDER_INVOICE: new Article({
        name: strictLocalize({
          id: "COn3iE",
          defaultMessage: [{
            "type": 0,
            "value": "Comprendre la facture d'une commande"
          }]
        }),
        id: "4416125712795"
      }),
      HOW_DO_I_PAY_FOR_ORDERS: new Article({
        name: strictLocalize({
          id: "1k8YBm",
          defaultMessage: [{
            "type": 0,
            "value": "Comment puis-je payer mes commandes ?"
          }]
        }),
        id: "360015892632"
      }),
      HOW_DO_I_CHANGE_MY_BILLING_ADDRESS: new Article({
        name: strictLocalize({
          id: "jdoE1a",
          defaultMessage: [{
            "type": 0,
            "value": "Comment modifier mon adresse de facturation ?"
          }]
        }),
        id: "24430827309467"
      })
    },
    INSIDER: {
      INSIDER_BRAND_PARTNERSHIP: new Article({
        name: strictLocalize({
          id: "H8tXRk",
          defaultMessage: [{
            "type": 0,
            "value": "Le partenariat Insider pour les marques"
          }]
        }),
        id: "25213101060123"
      })
    },
    FAQ: {
      RESETTING_PASSWORD: new Article({
        name: strictLocalize({
          id: "3o8L8n",
          defaultMessage: [{
            "type": 0,
            "value": "Réinitialiser mon mot de passe"
          }]
        }),
        id: "360019854651"
      }),
      RETAILER_WHAT_IS_FAIRE: new Article({
        name: strictLocalize({
          id: "lDcCOD",
          defaultMessage: [{
            "type": 0,
            "value": "Comment commencer à acheter sur Faire ?"
          }]
        }),
        id: RETAILER_WHAT_IS_FAIRE_ID
      }),
      EU_DSA: new Article({
        name: strictLocalize({
          id: "bdi6Mi",
          defaultMessage: [{
            "type": 0,
            "value": "Point de contact unique relatif au règlement européen sur les services numériques (DSA)"
          }]
        }),
        id: EU_DSA_ID
      }),
      HOW_RETURNS_WORK: new Article({
        name: strictLocalize({
          id: "3+R7cy",
          defaultMessage: [{
            "type": 0,
            "value": "Comment fonctionnent les retours ?"
          }]
        }),
        id: "360015892592"
      }),
      FAIRE_INSIDER_US: new Article({
        name: strictLocalize({
          id: "zPGP9w",
          defaultMessage: [{
            "type": 0,
            "value": "Comment fonctionne le programme Insider pour les commerçants américains ?"
          }]
        }),
        id: "4406840862747"
      }),
      FAIRE_INSIDER_EU: new Article({
        name: strictLocalize({
          id: "Ua9ksa",
          defaultMessage: [{
            "type": 0,
            "value": "Comment fonctionne le programme Insider pour les commerçants européens ?"
          }]
        }),
        id: "4418050425115"
      }),
      WHERE_IS_FAIRE_AVAILABLE: new Article({
        name: strictLocalize({
          id: "m68Icb",
          defaultMessage: [{
            "type": 0,
            "value": "Où les services de Faire sont-ils disponibles ?"
          }]
        }),
        id: WHERE_IS_FAIRE_AVAILABLE_ID
      }),
      BRAND_REFERRAL_PROGRAM_TERMS_CONDITIONS: new Article({
        name: strictLocalize({
          id: "rAW53+",
          defaultMessage: [{
            "type": 0,
            "value": "CONDITIONS GÉNÉRALES DU PROGRAMME DE PARRAINAGE FAIRE POUR LES MARQUES"
          }]
        }),
        id: "13628687993371"
      }),
      FAIRE_ACCOUNT_SECURITY: new Article({
        name: strictLocalize({
          id: "evS1O1",
          defaultMessage: [{
            "type": 0,
            "value": "Bonnes pratiques en matière de sécurité des comptes Faire"
          }]
        }),
        id: FAIRE_ACCOUNT_SECURITY_ID
      })
    },
    FAQForProspectiveBrands: {
      HOW_GET_PAID: new Article({
        name: strictLocalize({
          id: "LYRxSA",
          defaultMessage: [{
            "type": 0,
            "value": "Comment se fait la rémunération ?"
          }]
        }),
        id: "360015893272"
      }),
      FAIRE_COST: new Article({
        name: strictLocalize({
          id: "36qrix",
          defaultMessage: [{
            "type": 0,
            "value": "Vendre sur Faire, combien ça coûte ?"
          }]
        }),
        id: FAIRE_COST_ID
      }),
      BECOME_BRAND: new Article({
        name: strictLocalize({
          id: "ICLZE5",
          defaultMessage: [{
            "type": 0,
            "value": "Comment vendre sur Faire ?"
          }]
        }),
        id: BECOME_BRAND_ID
      })
    },
    International: {
      VAT_WORK_NON_EU_ORDERS: new Article({
        name: strictLocalize({
          id: "XXZP7G",
          defaultMessage: [{
            "type": 0,
            "value": "Comment fonctionne la TVA pour les commandes dans les pays européens hors UE ?"
          }]
        }),
        id: "4404431808155"
      }),
      PAY_VAT_NON_EU: new Article({
        name: strictLocalize({
          id: "MIkkag",
          defaultMessage: [{
            "type": 0,
            "value": "Comment vais-je payer la TVA sur mes commandes dans des pays européens non membres de l'UE ?"
          }]
        }),
        id: "4404431878683"
      }),
      VAT_WORK_EU_ORDERS: new Article({
        name: strictLocalize({
          id: "ox+alG",
          defaultMessage: [{
            "type": 0,
            "value": "Comment fonctionne la TVA pour les commandes au sein de l'UE ?"
          }]
        }),
        id: "360057747911"
      }),
      CANADIAN_RETAILERS: new Article({
        name: strictLocalize({
          id: "2l9kFh",
          defaultMessage: [{
            "type": 0,
            "value": "Premiers pas pour les commerçants canadiens"
          }]
        }),
        id: "360034894292"
      }),
      LOCATION_SHOP_LIVE: new Article({
        name: strictLocalize({
          id: "/BK1wq",
          defaultMessage: [{
            "type": 0,
            "value": "Puis-je choisir les zones géographiques où ma boutique est disponible ?"
          }]
        }),
        id: "360016524391"
      }),
      SELLING: new Article({
        name: strictLocalize({
          id: "vR2146",
          defaultMessage: [{
            "type": 0,
            "value": "Guide pour vendre à l'international sur Faire"
          }]
        }),
        id: "4407511671579"
      }),
      BUY: new Article({
        name: strictLocalize({
          id: "MAingx",
          defaultMessage: [{
            "type": 0,
            "value": "Comment acheter à l'international sur Faire ?"
          }]
        }),
        id: "4405345083675"
      })
    },
    ContactMyRetailer: {
      CONTACTING_MY_RETAILER: new Article({
        name: strictLocalize({
          id: "53rQbV",
          defaultMessage: [{
            "type": 0,
            "value": "Comment puis-je contacter mes commerçants sur Faire ?"
          }]
        }),
        id: CONTACTING_MY_RETAILER_ID
      })
    },
    BrandTermsAndPolicies: {
      DISPUTE_A_RETAILER_COMPLAINT: new Article({
        name: strictLocalize({
          id: "vFNhSP",
          defaultMessage: [{
            "type": 0,
            "value": "Contester la plainte d'un commerçant"
          }]
        }),
        id: DISPUTE_A_RETAILER_COMPLAINT_ID
      }),
      BRAND_POLICIES: new Article({
        name: strictLocalize({
          id: "lLVQEM",
          defaultMessage: [{
            "type": 0,
            "value": "Politiques des marques"
          }]
        }),
        id: BRAND_POLICIES_ID
      })
    },
    ImportFeesAndDuties: {
      DUTIES_REFUND: new Article({
        name: strictLocalize({
          id: "cgQGPC",
          defaultMessage: [{
            "type": 0,
            "value": "Que se passe-t-il lorsque Faire couvre mes droits de douane ?"
          }]
        }),
        id: "4403349101723"
      }),
      USA: new Article({
        name: strictLocalize({
          id: "lc7vKv",
          defaultMessage: [{
            "type": 0,
            "value": "Comment fonctionne l'expédition vers les États-Unis ?"
          }]
        }),
        id: "360031133351"
      }),
      Canada: new Article({
        name: strictLocalize({
          id: "zsTBx4",
          defaultMessage: [{
            "type": 0,
            "value": "Importation au Canada"
          }]
        }),
        id: "360057607832"
      }),
      Europe: new Article({
        name: strictLocalize({
          id: "XLscSH",
          defaultMessage: [{
            "type": 0,
            "value": "Importation en Europe"
          }]
        }),
        id: "360056061932"
      }),
      Australia: new Article({
        name: strictLocalize({
          id: "PXuWXh",
          defaultMessage: [{
            "type": 0,
            "value": "Importation en Australie"
          }]
        }),
        id: "6668590967579"
      }),
      EORI: new Article({
        name: strictLocalize({
          id: "93QqWi",
          defaultMessage: [{
            "type": 0,
            "value": "Comment demander un numéro EORI ?"
          }]
        }),
        id: "4409464460187"
      }),
      VAT: new Article({
        name: strictLocalize({
          id: "KVID5a",
          defaultMessage: [{
            "type": 0,
            "value": "Ai-je besoin d'un numéro de TVA ?"
          }]
        }),
        id: "4405333889435"
      })
    },
    Integration: {
      SOFTWARE_INTEGRATION_WITH_FAIRE: new Article({
        name: strictLocalize({
          id: "M/W49R",
          defaultMessage: [{
            "type": 0,
            "value": "Intégration logicielle avec Faire"
          }]
        }),
        id: "360037964391"
      }),
      ONBOARDING_WITH_SHOPIFY: new Article({
        name: strictLocalize({
          id: "SDYcWM",
          defaultMessage: [{
            "type": 0,
            "value": "Intégration avec Shopify"
          }]
        }),
        id: "4407533398939"
      }),
      CAN_I_INTEGRATE_WITH_SHOPIFY: new Article({
        name: strictLocalize({
          id: "rkM/49",
          defaultMessage: [{
            "type": 0,
            "value": "Existe-t-il une intégration à Shopify ?"
          }]
        }),
        id: "360054245292"
      })
    }
  };
  return articles;
};